import { useQuery } from 'react-query';

import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';

import type { DraftManual } from 'views/App/Portal/Policy/_types/manuals/draft';

export async function getDraftManual(id: string): Promise<DraftManual> {
  const url = `${baseApiUrl()}/lexiverse-manual-api/v1/manuals/${id}`;
  const data = await fetcher({
    method: 'get',
    url,
  });
  return data;
}

export default function useDraftManual(id?: string, options = {}, onError?: (errors: ServerErrorResponse) => void) {
  return useQuery<DraftManual, ServerErrorResponse>(
    ['draft_manual', id],
    async () => {
      try {
        return await getDraftManual(id!);
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      ...options,
      enabled: !!id,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      refetchInterval: 1000 * 60 * 60 * 24 * 15, // 15 days - effectively never during a session
      staleTime: Infinity, // Never mark data as stale - prevents refetches during editing
    }
  );
}
